import Cookies from 'js-cookie';
import moment from 'moment';

import { Event, User } from 'app/shared/typings';

interface CookiesProps {
  event: Event;
  loggedInUser?: User | null;
  orderEventAttendeeUser?: User;
  attendeeTotalTickets?: number;
  numberOfTickets: number;
}

export const updateCheckoutCookies = ({
  event,
  loggedInUser,
  orderEventAttendeeUser,
  attendeeTotalTickets,
  numberOfTickets,
}: CookiesProps) => {
  Cookies.set('last_purchased_at', moment().toISOString(), {
    expires: 60,
  });
  Cookies.set('last_purchased_event_id', event.id.toString() || '', {
    expires: 60,
  });
  Cookies.set(
    'last_purchased_user_id',
    (loggedInUser?.id || orderEventAttendeeUser?.id)?.toString() || '',
    {
      expires: 60,
    }
  );

  if (!loggedInUser) {
    Cookies.set(
      'guest_last_purchased_num_tickets',
      attendeeTotalTickets?.toString() || numberOfTickets.toString(),
      {
        expires: 60,
      }
    );
  }
};
